export const environment = {
    production: false,
    environmentName: 'development',
    recaptchaKey: "6LeUer8rAAAAAG0X_LdCKswr5iZuCNxG91GXvfdQ",
    baseUrl: "https://apimeu2crypd01.azure-api.net/cryp/v1/",
    keyBaseUrl: "05dc157f4eb94fa0aac6e75e968ee270",
    analytics: {
        enabled: true,
        measurementId: "G-GWLFWE660M",
        debug: true
    }
};